export const MEGABYTES_IN_GIGABYTE = 1000
export const MAX_AUDIO_DURATION_RINGLESS_SELECT = 180
